import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";

interface PostContentDeletedProps extends React.HTMLAttributes<HTMLDivElement> {
	type: "course" | "quiz" | "post" | "organization" | "group" | "article" | "carousel" | "live" | "application";
}

export const PostContentDeleted: React.FC<PostContentDeletedProps> = ({ type, ...htmlProps }) => {
	return <Container {...htmlProps}>{I18n.t(`post.${type}.deleted`)}</Container>;
};

const Container = styled(RoundedBlock)`
	${({ theme }) => theme.textStyles.secondary};
	padding: 20px 20px;
	font-style: italic;
	text-align: center;
`;
